import { useState, useEffect } from "react";
import { CategoryButton } from "src/shared/services/interfacev2";
import { errorHandling } from "src/shared/utils/errorHandling";
import { getCategory } from "src/shared/services/servicesv2";

export const useCategoryData = () => {
  const [buttonNames, setButtonNames] = useState<CategoryButton[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const getCategorys = () => {
    setLoading(true);

    getCategory().then((res)=>{
      const categoryData: CategoryButton[] = res.data.categoryDetails;
      setButtonNames(categoryData);
       setLoading(false);
    }).catch((error)=>{errorHandling(error); setLoading(false);})
  };

  useEffect(() => {
    getCategorys();
  }, []);

  return { buttonNames, loading, getCategory };
};
